import styled from 'vue3-styled-components';

// 블러 효과를 위한 스타일 추가 - 테이블 데이터만 블러 처리
export const BlurOverlay = styled.div`
  &.blurred {
    /* 테이블 본문의 모든 셀을 블러 처리 */
    tbody tr td {
      filter: blur(8px) !important;
    }
    
    /* 테이블 내부의 span, div 요소들 */
    tbody tr td span,
    tbody tr td div {
      filter: blur(8px) !important;
    }
    
    /* 체크박스는 블러 처리하지 않음 */
    tbody tr td input[type="checkbox"] {
      filter: none !important;
    }
  }
`;

export const OrderDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: 50px;
    padding-right: 50px;
`;

export const OrderTitleArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const TitleDiv = styled.h1` 
    font-size: 30px;
    text-align: center;
    font-weight: bold;
    color: #cc5803;
`;

export const OrderHeaderArea = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 10px 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    position: relative;
    margin-bottom: 20px;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        border-radius: 16px 16px 0 0;
    }
`;

export const OrderHeaderButtonArea = styled.div`
    display: flex;
    width: 100%;
    padding: 16px 0;
    flex-wrap: nowrap;
    align-items: center;
    gap: 24px;

    @media (max-width: 1200px) {
        flex-wrap: wrap;
        gap: 16px;
    }
`;

export const OrderSection = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;
    
    &:first-child {
        padding-left: 0;
        flex: 0 0 auto;
    }

    /* 피드백 섹션을 오른쪽 끝으로 이동 */
    &.feedback-section {
        margin-left: auto;
        flex-shrink: 0;
    }

    @media (max-width: 1200px) {
        &.feedback-section {
            margin-left: 0;
            order: 3;
            width: 100%;
            justify-content: center;
        }
    }
`;

export const OrderSearchWrapper = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 35px;
    max-width: 300px;
`;

export const OrderSearchInput = styled.input`
  padding: 8px 12px;
  border: none;
  outline: none;
  font-size: 14px;
  flex: 1;
  min-width: 0;

  &:focus {
    outline: none;
    border: 1px solid #0f4c5c;
  }
`;

export const DetailSearchTagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  margin-bottom: 16px;
`;

export const DetailSearchTagsTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  white-space: nowrap;
`;

export const DetailSearchTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
`;

export const DetailSearchTag = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #007bff;
  color: white;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: #0056b3;
    transform: translateY(-1px);
  }
`;

export const DetailSearchTagText = styled.span`
  font-weight: 500;
`;

export const DetailSearchTagClose = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

export const ClearAllFiltersButton = styled.button`
  padding: 6px 12px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;

  &:hover {
    background-color: #545b62;
  }
`;

export const OrderTableButtonArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const OrderDateInput = styled.input`
    width: 8%;
    height: 35px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;

const OrderButtonCss = `
    height: 35px;
    line-height: 10px;
    color: white;
    border: none;
    padding: 0 10px;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    margin: 0 3px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;


export const OrderButton = styled.button`
    ${OrderButtonCss}
    width: 90px;
    background: #0f4c5c;
    flex-shrink: 0;
    margin-left: 10px;
    margin-right: 10px;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const OrderButtonExcel = styled.button`
    ${OrderButtonCss}
    background: rgb(48, 110, 72);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
`;

export const OrderSearchBtn = styled.button`
  background-color: transparent;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  
  &:hover {
    color: #0f4c5c;
  }
  
  &:last-child {
    border-left: 1px solid #eee;
  }
`;

export const OrderDateButton = styled.button`
    ${OrderButtonCss}
    background-color: #0f4c5c;
    padding: 0 8px;
    font-size: 13px;
    flex-shrink: 0;
    width: 50px;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const DatepickerWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    margin-left: 50px;
    margin-right: 50px;
`;

export const DateSeparator = styled.span`
    color: #666;
    margin: 0 2px;
`;

export const DateButtonsWrapper = styled.div`
  display: flex;
  gap: 5px;
`;

export const OrderHeaderInfoArea = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    width:30%;
`;

export const OrderHeaderInfo = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    width:100%;
`;

export const OrderTableArea = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    border: 1px solid #e8ecf0;
    
    @media (max-width: 1200px) {
        padding: 16px;
        border-radius: 12px;
    }
    
    @media (max-width: 768px) {
        padding: 12px;
        border-radius: 10px;
    }
    
    @media (max-width: 480px) {
        padding: 8px;
        border-radius: 8px;
    }
`;


// 버튼 컨테이너 추가
export const OrderTableButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }
`;

// 왼쪽 버튼 그룹
export const OrderTableLeftButtons = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

// 오른쪽 버튼 그룹
export const OrderTableRightButtons = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

export const OrderPageSelect = styled.select`
    padding: 12px 20px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
    color: #1e293b;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    min-width: 50px;
    margin-left: 10px;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        background: #ffffff;
    }

    &:hover {
        border-color: #cbd5e1;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    option {
        background: #ffffff;
        color: #1e293b;
        padding: 8px;
    }
`;

export const OrderUploadBtn = styled.button`
    padding: 12px 20px;
    border-radius: 12px;
    cursor: pointer;
    border: none;
    background: #2563eb;
    color: #ffffff;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(59, 130, 246, 0.4);
        background: #1e40af;
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
    }
`;

// 기존 버튼 스타일들 수정
export const OrderUpButton = styled.button`
    padding: 12px 20px;
    border-radius: 12px;
    cursor: pointer;
    border: none;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: #ffffff;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
        background: linear-gradient(135deg, #0f3c48 0%, #1a6b7a 100%);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
    }
`;

export const OrderDeleteBtn = styled.button`
    padding: 12px 20px;
    border-radius: 12px;
    cursor: pointer;
    border: none;
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
    color: #ffffff;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(255, 107, 107, 0.4);
        background: linear-gradient(135deg, #ff5252 0%, #d32f2f 100%);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
    }
`;

export const OrderTableButton = styled.button`
    background: #ffffff;
    width: calc(50% + 40px);
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    border: 2px solid #e8ecf0;
    position: relative;
    margin-right: -2px;
    color: #64748b;

    &:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 0;
    }

    &:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 0;
        margin-right: 0;
    }

    &.active {
        background: #0f4c5c;
        color: #ffffff;
        border-color: #0f4c5c;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        z-index: 2;
    }
`;

export const OrderStatusCnt = styled.div`
    padding: 5px 5px;
    font-size: 20px;
    font-weight: bold;
    
    @media (max-width: 1200px) {
        font-size: 18px;
        padding: 4px 4px;
    }
    
    @media (max-width: 768px) {
        font-size: 16px;
        padding: 3px 3px;
    }
    
    @media (max-width: 480px) {
        font-size: 14px;
        padding: 2px 2px;
    }
`;

export const OrderStatusTitle = styled.div`
    padding: 5px 15px;
    font-size: 17px;
    font-weight: bold;
    background: #ff0000;
    color:#fff;
    border-radius: 10px;
    margin-right: 8px;
    
    &.all {
        background: #fb8b24;
        color: #fff;
    }
    &.unconfirm, &.oxygen {
        background: #FDC800;
        color: #fff;
    }
    &.confirm, &.diabetes {
        background: #00BC2A;
        color: #fff;
    }
    &.release {
        background: #0f4c5c;
        color: #fff;
    }
    &.councel, &.assistance {
        background: #5783FC;
        color: #fff;
    }
    &.return {
        background: #FF4243;
        color: #fff;
    }
    &.as {
        background: #6C2EF1;
        color: #fff;
    }
    
    @media (max-width: 1200px) {
        padding: 4px 12px;
        font-size: 16px;
        border-radius: 8px;
        margin-right: 6px;
    }
    
    @media (max-width: 768px) {
        padding: 3px 10px;
        font-size: 15px;
        border-radius: 6px;
        margin-right: 4px;
    }
    
    @media (max-width: 480px) {
        padding: 2px 8px;
        font-size: 14px;
        border-radius: 5px;
        margin-right: 3px;
    }
`;

export const OrderPageLeftArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    color: #000;
    font-weight: bold;
`;

export const OrderPageRightArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
`;

export const OrderPageCenterArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    margin-top: 20px;
`;

// 청구 상태 범례 컨테이너
export const ClaimStatusLegend = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    margin-right: 12px;

    @media (max-width: 768px) {
        margin-right: 8px;
        padding: 8px 12px;
    }
`;

// 청구 상태 제목
export const ClaimStatusTitle = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 4px;
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;

// 청구 상태 아이템 컨테이너
export const ClaimStatusItems = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    width: 100%;
`;

// 청구 상태 아이템
export const ClaimStatusItem = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    gap: 2px;
    margin-right: 5px;
`;

// 청구 상태 아이콘
export const RightClaimStatusIcon = styled.span`
    text-align: center;
    line-height: 1;
    padding-top: 3px;

    &.completed {
        color: #10b981;
    }

    &.in-progress {
        color: #f59e0b;
    }

    &.not-claimed {
        color: #ef4444;
    }

    @media (max-width: 768px) {
        font-size: 14px;
        width: 16px;
    }
`;

// 청구 상태 텍스트
export const RightClaimStatusText = styled.span`
    font-size: 12px;
    color: #64748b;

    @media (max-width: 768px) {
        font-size: 11px;
    }
`;

// 테이블 스크롤 컨테이너
export const OrderTableScrollContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    
  /* 웹킷 기반 브라우저 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    margin: 0 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1, #94a3b8);
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;
      
      &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
      }
      
      &:active {
        background: linear-gradient(135deg, #64748b, #475569);
      }
  }
  
  &::-webkit-scrollbar-corner {
    background: #f1f5f9;
  }
`;

export const OrderTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    font-size: 15px;
    background: #ffffff;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 1200px) {
        font-size: 14px;
        table-layout: fixed; /* 고정 레이아웃 유지 */
    }
    
    @media (max-width: 768px) {
        font-size: 13px;
        table-layout: auto; /* 작은 화면에서는 자동 레이아웃 */
        min-width: 800px; /* 최소 너비 설정으로 가로 스크롤 보장 */
    }
    
    @media (max-width: 480px) {
        font-size: 12px;
        min-width: 600px; /* 모바일에서 최소 너비 조정 */
    }
`;

export const OrderTableHead = styled.thead`
    background: #fb8b24;
    color: #000;

    /* AS 테이블 */
    &.as-table {
        th:nth-child(1) { width: 20px; }   /* 체크박스 */
        th:nth-child(2) { width: 100px; }  /* A/S접수일 */
        th:nth-child(3) { width: 120px; }  /* 고객명 */
        th:nth-child(4) { width: 120px; }  /* 연락처 */
        th:nth-child(5) { width: 150px; }  /* A/S품목 */
        th:nth-child(6) { width: 30px; }   /* 수량 */
        th:nth-child(7) { width: 100px; }   /* 메모 */
        th:nth-child(8) { width: 100px; }  /* A/S사유 */
        th:nth-child(9) { width: 100px; }  /* A/S상태 */
        th:nth-child(10) { width: 35px; }   /* 상담중 */
        th:nth-child(11) { width: 35px; }   /* 복사 */
        
        @media (max-width: 1200px) {
            th:nth-child(1) { width: 25px; }   /* 체크박스 */
            th:nth-child(2) { width: 90px; }   /* A/S접수일 */
            th:nth-child(3) { width: 110px; }  /* 고객명 */
            th:nth-child(4) { width: 110px; }  /* 연락처 */
            th:nth-child(5) { width: 130px; }  /* A/S품목 */
            th:nth-child(6) { width: 28px; }   /* 수량 */
            th:nth-child(7) { width: 90px; }   /* 메모 */
            th:nth-child(8) { width: 90px; }   /* A/S사유 */
            th:nth-child(9) { width: 90px; }   /* A/S상태 */
            th:nth-child(10) { width: 32px; }  /* 상담중 */
            th:nth-child(11) { width: 32px; }  /* 복사 */
        }
        
        @media (max-width: 768px) {
            th:nth-child(1) { width: 25px; }   /* 체크박스 */
            th:nth-child(2) { width: 80px; }   /* A/S접수일 */
            th:nth-child(3) { width: 90px; }   /* 고객명 */
            th:nth-child(4) { width: 90px; }   /* 연락처 */
            th:nth-child(5) { width: 120px; }  /* A/S품목 */
            th:nth-child(6) { width: 25px; }   /* 수량 */
            th:nth-child(7) { width: 80px; }   /* 메모 */
            th:nth-child(8) { width: 80px; }   /* A/S사유 */
            th:nth-child(9) { width: 80px; }   /* A/S상태 */
            th:nth-child(10) { width: 30px; }  /* 상담중 */
            th:nth-child(11) { width: 30px; }  /* 복사 */
        }
        
        @media (max-width: 480px) {
            th:nth-child(1) { width: 20px; }   /* 체크박스 */
            th:nth-child(2) { width: 70px; }   /* A/S접수일 */
            th:nth-child(3) { width: 70px; }   /* 고객명 */
            th:nth-child(4) { width: 70px; }   /* 연락처 */
            th:nth-child(5) { width: 100px; }  /* A/S품목 */
            th:nth-child(6) { width: 20px; }   /* 수량 */
            th:nth-child(7) { width: 60px; }   /* 메모 */
            th:nth-child(8) { width: 60px; }   /* A/S사유 */
            th:nth-child(9) { width: 60px; }   /* A/S상태 */
            th:nth-child(10) { width: 25px; }  /* 상담중 */
            th:nth-child(11) { width: 25px; }  /* 복사 */
        }
    }

    /* 반품 테이블 */
    &.return-table {
        th:nth-child(1) { width: 20px; }   /* 체크박스 */
        th:nth-child(2) { width: 100px; }  /* 반품접수일 */
        th:nth-child(3) { width: 100px; }  /* 고객명 */
        th:nth-child(4) { width: 120px; }  /* 연락처 */
        th:nth-child(5) { width: 200px; }  /* 반품품목 */
        th:nth-child(6) { width: 60px; }   /* 반품수량 */
        th:nth-child(7) { width: 200px; }  /* 반품사유 */
        th:nth-child(8) { width: 100px; }  /* 반품상태 */
        th:nth-child(9) { width: 80px; }   /* 담당자 */
        th:nth-child(10) { width: 150px; } /* 메모 */
        th:nth-child(11) { width: 100px; } /* 반품완료일 */
        th:nth-child(12) { width: 35px; }  /* 상담중 */
        th:nth-child(13) { width: 35px; }  /* 복사 */
        
        @media (max-width: 1200px) {
            th:nth-child(1) { width: 25px; }   /* 체크박스 */
            th:nth-child(2) { width: 90px; }   /* 반품접수일 */
            th:nth-child(3) { width: 90px; }   /* 고객명 */
            th:nth-child(4) { width: 110px; }  /* 연락처 */
            th:nth-child(5) { width: 180px; }  /* 반품품목 */
            th:nth-child(6) { width: 55px; }   /* 반품수량 */
            th:nth-child(7) { width: 180px; }  /* 반품사유 */
            th:nth-child(8) { width: 90px; }   /* 반품상태 */
            th:nth-child(9) { width: 70px; }   /* 담당자 */
            th:nth-child(10) { width: 130px; } /* 메모 */
            th:nth-child(11) { width: 90px; }  /* 반품완료일 */
            th:nth-child(12) { width: 32px; }  /* 상담중 */
            th:nth-child(13) { width: 32px; }  /* 복사 */
        }
        
        @media (max-width: 768px) {
            th:nth-child(1) { width: 25px; }   /* 체크박스 */
            th:nth-child(2) { width: 80px; }   /* 반품접수일 */
            th:nth-child(3) { width: 80px; }   /* 고객명 */
            th:nth-child(4) { width: 90px; }   /* 연락처 */
            th:nth-child(5) { width: 150px; }  /* 반품품목 */
            th:nth-child(6) { width: 50px; }   /* 반품수량 */
            th:nth-child(7) { width: 150px; }  /* 반품사유 */
            th:nth-child(8) { width: 80px; }   /* 반품상태 */
            th:nth-child(9) { width: 60px; }   /* 담당자 */
            th:nth-child(10) { width: 120px; } /* 메모 */
            th:nth-child(11) { width: 80px; }  /* 반품완료일 */
            th:nth-child(12) { width: 30px; }  /* 상담중 */
            th:nth-child(13) { width: 30px; }  /* 복사 */
        }
        
        @media (max-width: 480px) {
            th:nth-child(1) { width: 20px; }   /* 체크박스 */
            th:nth-child(2) { width: 60px; }   /* 반품접수일 */
            th:nth-child(3) { width: 60px; }   /* 고객명 */
            th:nth-child(4) { width: 70px; }   /* 연락처 */
            th:nth-child(5) { width: 120px; }  /* 반품품목 */
            th:nth-child(6) { width: 40px; }   /* 반품수량 */
            th:nth-child(7) { width: 100px; }  /* 반품사유 */
            th:nth-child(8) { width: 60px; }   /* 반품상태 */
            th:nth-child(9) { width: 50px; }   /* 담당자 */
            th:nth-child(10) { width: 80px; }  /* 메모 */
            th:nth-child(11) { width: 60px; }  /* 반품완료일 */
            th:nth-child(12) { width: 25px; }  /* 상담중 */
            th:nth-child(13) { width: 25px; }  /* 복사 */
        }
    }
    
    /* 테이블 헤더의 각 컬럼 너비 설정 */
    &.normal-table {
        th:nth-child(1) { width: 30px; } /* 체크박스 */
        th:nth-child(2) { width: 80px; } /* 일자 */
        th:nth-child(3) { width: 100px; } /* 고객명 */
        th:nth-child(4) { width: 100px; } /* 고객번호 */
        th:nth-child(5) { width: 200px; } /* 품목명 */
        th:nth-child(6) { width: 30px; } /* 품목수량 */
        th:nth-child(7) { width: 200px; } /* 배송주소 */
        th:nth-child(8) { width: 50px; } /* 보호자성함 */
        th:nth-child(9) { width: 110px; } /* 연락처 */
        th:nth-child(10) { width: 120px; } /* 거래처 */
        th:nth-child(11) { width: 50px; } /* 담당자 */
        th:nth-child(12) { width: 150px; } /* 메모 */
        th:nth-child(13) { width: 60px; } /* 배송방법 */
        th:nth-child(14) { width: 60px; } /* 배송상태 */
        th:nth-child(15) { width: 60px; } /* 구분 */
        th:nth-child(16) { width: 40px; } /* 상담중 */
        th:nth-child(17) { width: 30px; } /* 복사 */
        
        @media (max-width: 1200px) {
            th:nth-child(1) { width: 28px; } /* 체크박스 */
            th:nth-child(2) { width: 80px; } /* 일자 */
            th:nth-child(3) { width: 90px; } /* 고객명 */
            th:nth-child(4) { width: 90px; } /* 고객번호 */
            th:nth-child(5) { width: 180px; } /* 품목명 */
            th:nth-child(6) { width: 28px; } /* 품목수량 */
            th:nth-child(7) { width: 180px; } /* 배송주소 */
            th:nth-child(8) { width: 45px; } /* 보호자성함 */
            th:nth-child(9) { width: 100px; } /* 연락처 */
            th:nth-child(10) { width: 110px; } /* 거래처 */
            th:nth-child(11) { width: 45px; } /* 담당자 */
            th:nth-child(12) { width: 130px; } /* 메모 */
            th:nth-child(13) { width: 55px; } /* 배송방법 */
            th:nth-child(14) { width: 55px; } /* 배송상태 */
            th:nth-child(15) { width: 55px; } /* 구분 */
            th:nth-child(16) { width: 32px; } /* 상담중 */
            th:nth-child(17) { width: 28px; } /* 복사 */
        }
        
        @media (max-width: 768px) {
            th:nth-child(1) { width: 25px; } /* 체크박스 */
            th:nth-child(2) { width: 70px; } /* 일자 */
            th:nth-child(3) { width: 80px; } /* 고객명 */
            th:nth-child(4) { width: 80px; } /* 고객번호 */
            th:nth-child(5) { width: 150px; } /* 품목명 */
            th:nth-child(6) { width: 25px; } /* 품목수량 */
            th:nth-child(7) { width: 150px; } /* 배송주소 */
            th:nth-child(8) { width: 40px; } /* 보호자성함 */
            th:nth-child(9) { width: 90px; } /* 연락처 */
            th:nth-child(10) { width: 100px; } /* 거래처 */
            th:nth-child(11) { width: 40px; } /* 담당자 */
            th:nth-child(12) { width: 120px; } /* 메모 */
            th:nth-child(13) { width: 50px; } /* 배송방법 */
            th:nth-child(14) { width: 50px; } /* 배송상태 */
            th:nth-child(15) { width: 50px; } /* 구분 */
            th:nth-child(16) { width: 30px; } /* 상담중 */
            th:nth-child(17) { width: 25px; } /* 복사 */
        }
        
        @media (max-width: 480px) {
            th:nth-child(1) { width: 20px; } /* 체크박스 */
            th:nth-child(2) { width: 60px; } /* 일자 */
            th:nth-child(3) { width: 60px; } /* 고객명 */
            th:nth-child(4) { width: 60px; } /* 고객번호 */
            th:nth-child(5) { width: 120px; } /* 품목명 */
            th:nth-child(6) { width: 20px; } /* 품목수량 */
            th:nth-child(7) { width: 100px; } /* 배송주소 */
            th:nth-child(8) { width: 30px; } /* 보호자성함 */
            th:nth-child(9) { width: 70px; } /* 연락처 */
            th:nth-child(10) { width: 80px; } /* 거래처 */
            th:nth-child(11) { width: 30px; } /* 담당자 */
            th:nth-child(12) { width: 80px; } /* 메모 */
            th:nth-child(13) { width: 40px; } /* 배송방법 */
            th:nth-child(14) { width: 40px; } /* 배송상태 */
            th:nth-child(15) { width: 40px; } /* 구분 */
            th:nth-child(16) { width: 25px; } /* 상담중 */
            th:nth-child(17) { width: 20px; } /* 복사 */
        }
    }
`;

export const OrderTableTrTh = styled.th`
    padding: 10px 10px;
    text-align: center;
    border-bottom: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    
    input {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
    
    @media (max-width: 1200px) {
        padding: 8px 8px;
        font-size: 13px;
        
        input {
            width: 18px;
            height: 18px;
        }
    }
    
    @media (max-width: 768px) {
        padding: 6px 6px;
        font-size: 12px;
        
        input {
            width: 16px;
            height: 16px;
        }
    }
    
    @media (max-width: 480px) {
        padding: 4px 4px;
        font-size: 11px;
        
        input {
            width: 14px;
            height: 14px;
        }
    }
`;

export const OrderTableTrTd = styled.td`
    padding: 6px 8px;
    text-align: center;
    border-bottom: 1px solid #ffeccc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #374151;

    input {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    .as-table & {
        &:nth-child(5),
        &:nth-child(7) {
            text-align: left;
            padding-left: 20px;
        }
    }

    .return-table & {
        &:nth-child(5),
        &:nth-child(7),
        &:nth-child(10) {
            text-align: left;
            padding-left: 20px;
        }
    }
    
    @media (max-width: 1200px) {
        padding: 5px 8px;
        font-size: 13px;
        
        input {
            width: 18px;
            height: 18px;
        }
        
        .as-table & {
            &:nth-child(5),
            &:nth-child(7) {
                padding-left: 16px;
            }
        }

        .return-table & {
            &:nth-child(5),
            &:nth-child(7),
            &:nth-child(10) {
                padding-left: 16px;
            }
        }
    }
    
    @media (max-width: 768px) {
        padding: 4px 6px;
        font-size: 12px;
        
        input {
            width: 16px;
            height: 16px;
        }
        
        .as-table & {
            &:nth-child(5),
            &:nth-child(7) {
                padding-left: 12px;
            }
        }

        .return-table & {
            &:nth-child(5),
            &:nth-child(7),
            &:nth-child(10) {
                padding-left: 12px;
            }
        }
    }
    
    @media (max-width: 480px) {
        padding: 3px 4px;
        font-size: 11px;
        
        input {
            width: 14px;
            height: 14px;
        }
        
        .as-table & {
            &:nth-child(5),
            &:nth-child(7) {
                padding-left: 8px;
            }
        }

        .return-table & {
            &:nth-child(5),
            &:nth-child(7),
            &:nth-child(10) {
                padding-left: 8px;
            }
        }
    }
`;

export const SetItemTag = styled.span`
  background-color: #e6f7ff;
  color: #1890ff;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 4px;
  font-weight: bold;
`;

// * 페이지네이션
export const Pagination = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PaginationButton = styled.button`
    padding: 6px 8px;
    border: 2px solid #e8ecf0;
    background: #ffffff;
    color: #64748b;
    border-radius: 12px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
        background: rgba(102, 126, 234, 0.05);
        transform: translateY(-1px);
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const PaginationNumber = styled.button`
    min-width: 40px;
    height: 40px;
    padding: 0 12px;
    border: 2px solid #e8ecf0;
    background: #ffffff;
    color: #64748b;
    border-radius: 12px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;
    
    &.current-page, &.active {
        background: #fb8b24;
        color: #ffffff;
        border-color: #fb8b24;
    }
    
    &:hover:not(:disabled):not(.current-page):not(.active) {
        border-color: #fb8b24;
        color: #fb8b24;
        transform: translateY(-1px);
    }
`;

export const BtnContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 8px;
`;

// 구분 필터 관련 스타일 추가
export const OrderTypeFilterWrapper = styled.div`
    position: relative;
    display: inline-block;
`;

export const OrderTypeFilterButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    color: #333;
    padding: 5px 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 5px;
    
    &:hover {
        background-color: #f5f5f5;
    }
    
    &.active {
        background-color: #0f4c5c;
        color: white;
    }
`;

export const OrderTypeFilterDropdown = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    min-width: 120px;
    max-height: 200px;
    overflow-y: auto;
`;

export const OrderTypeFilterOption = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    border-bottom: 1px solid #f0f0f0;
    
    &:hover {
        background-color: #f5f5f5;
    }
    
    &:last-child {
        border-bottom: none;
    }
    
    &.selected {
        background-color: #0f4c5c;
        color: white;
    }
`;

export const FilterChevron = styled.span`
    font-size: 12px;
    transition: transform 0.2s;
    
    &.open {
        transform: rotate(180deg);
    }
`;

export const OrderTypeTag = styled.span`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &.normal {
    background-color: #f8f1e9;
    color: #cc5803;
    border: 2px solid #cc5803;
  }
  
  &.rental {
    background-color: #e3f2fd;
    color: #1976d2;
    border: 2px solid #1976d2;
  }
  
  &.oxygen {
    background-color: #f3e5f5;
    color: #6b46c1;
    border: 2px solid #6b46c1;
  }

  &.assistance {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 2px solid #2e7d32;
  }
  
  &.diabetes {
    background-color: #e0f7f5;
    color: #00998b;
    border: 2px solid #00998b;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const OrderTableTbody = styled.tbody`
`;

export const NegativeQuantitySpan = styled.span`
  color: #dc3545;
  font-weight: 600;
  background-color: rgba(220, 53, 69, 0.1);
  border-radius: 4px;
  padding: 3px 5px;
  border: 1px solid #dc3545;
  display: inline-block;
  text-align: center;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.1);
  animation: pulse 2s infinite;
  min-width: 23px;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const ReturnQuantitySpan = styled.span`
  color: #dc3545;
  font-weight: 600;
  background-color: rgba(220, 53, 69, 0.1);
  border-radius: 4px;
  padding: 3px 5px;
  border: 1px solid #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.1);
  animation: pulse 2s infinite;
  min-width: 23px;
  max-width: 30px;
  margin-top: 5px;
  margin-left: 25px;
  height: 24px;
  font-size: 14px;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
`;

// 반품 상태 태그 스타일
export const ReturnStatusTag = styled.span`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &.status-0 {
    background-color: #fff3cd;
    color: #856404;
    border: 2px solid #ffeaa7;
  }
  
  &.status-1 {
    background-color: #d1ecf1;
    color: #0c5460;
    border: 2px solid #bee5eb;
  }
  
  &.status-2 {
    background-color: #d4edda;
    color: #155724;
    border: 2px solid #c3e6cb;
  }
  
  &.status-3 {
    background-color: #f8d7da;
    color: #721c24;
    border: 2px solid #f5c6cb;
  }
  
  &.status-4 {
    background-color: #e2e3e5;
    color: #383d41;
    border: 2px solid #d6d8db;
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

// 반품 유형 태그 스타일
export const ReturnTypeTag = styled.span`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &.type-1 {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 2px solid #c8e6c9;
  }
  
  &.type-2 {
    background-color: #fff3e0;
    color: #ef6c00;
    border: 2px solid #ffcc02;
  }
  
  &.type-3 {
    background-color: #f3e5f5;
    color: #6b46c1;
    border: 2px solid #e1bee7;
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

// A/S 상태 태그 스타일
export const AsStatusTag = styled.span`
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &.status-0 {
    background-color: #fff3cd;
    color: #856404;
    border: 2px solid #ffeaa7;
  }
  
  &.status-1 {
    background-color: #d1ecf1;
    color: #0c5460;
    border: 2px solid #bee5eb;
  }
  
  &.status-2 {
    background-color: #f8d7da;
    color: #721c24;
    border: 2px solid #f5c6cb;
  }
  
  &.status-3 {
    background-color: #d4edda;
    color: #155724;
    border: 2px solid #c3e6cb;
  }
  
  &.status-4 {
    background-color: #e2e3e5;
    color: #383d41;
    border: 2px solid #d6d8db;
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

// A/S 수량 스타일 (음수일 때)
export const AsQuantitySpan = styled.span`
  color: #dc3545;
  font-weight: 600;
  background-color: rgba(220, 53, 69, 0.1);
  border-radius: 4px;
  padding: 3px 5px;
  border: 1px solid #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.1);
  animation: pulse 2s infinite;
  min-width: 23px;
  max-width: 30px;
  margin-left: 10px;
  height: 24px;
  font-size: 14px;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const OrderTableTr = styled.tr`
    border-bottom: 1px solid #ccc;

    &.success {
        background: #dff0d8;
    }
    &.danger {
        background: #f2dede;
    }
    &.warning {
        background: #fcf8e3;
    }
    &.info {
        background: #d9edf7;
    }
    &.order_tr{
        &:hover {
            background: #ffeccc;
            color:#000;
            cursor: pointer;
        }
    }
    
    // 만료된 주문서 스타일 추가
    &.expired-order {
        background: linear-gradient(135deg, #fff5f5 0%, #ffffff 50%, #fff5f5 100%) !important;
        border-left: 4px solid #ff6b6b !important;
        position: relative;
        animation: expiredPulse 3s infinite;
        
        &:hover {
            background: linear-gradient(135deg, #ffebee 0%, #f8f9fa 50%, #ffebee 100%) !important;
            transform: translateX(2px);
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);
        }
        
        td {
            border-color: #ffcdd2 !important;
            color: #d32f2f !important;
            font-weight: 500;
            position: relative;
        }
    }
    
      @media (max-width: 768px) {
        &.order_tr:hover {
            background: #fff5e6;
      }
    }
`;

export const OrderPagePrintBtn = styled.button`
    width: 200px;
    box-shadow: 0 8px 9px -4px rgba(255, 255, 255, 0.082), 0 4px 18px 0 rgba(253, 253, 253, 0.089);
    border-radius: 5px;
    border:none;
    background: #0f4c5c;
    color: #fff;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    font-size: 18px;
    margin-right:20px;
`;

export const FilterArea = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-top: 10px;
`;

export const FilterDiv = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 16px;
  color: #333;
  margin-right: 5px;
  margin-bottom: 5px;
`;

export const FilterDeleteBtn = styled.button`
  background: none;
  border: none;
  color: red;
  margin-left: 5px;
  cursor: pointer;
  padding: 0 2px;
  font-size: 14px;
  
  &:hover {
    color: #f44336;
  }
`;

export const ExcelModalDiv = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ExcelModalTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const ExcelTabArea = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

export const ExcelTabButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;

  &.active {
    background: #007bff;
    color: white;
    border-color: #007bff;
  }
`;

export const ExcelSearchArea = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

export const ExcelSearchInput = styled.input`
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

export const ExcelSearchButton = styled.button`
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

export const ExcelTableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
`;

export const ExcelButtonArea = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const ExcelCancelButton = styled.button`
  padding: 8px 24px;
  border: 1px solid #dc3545;
  border-radius: 4px;
  background: white;
  color: #dc3545;
  cursor: pointer;
`;

export const ExcelConfirmButton = styled.button`
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  background: #007bff;
  color: white;
  cursor: pointer;
`;

export const OrderCopyBtn = styled.button`
  cursor: pointer;
  color: #0f4c5c;
  background: none;
  border: none;
  padding: 5px 10px;
  font-size: 16px;
  transition: color 0.3s;
  font-weight: bold;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// 청구 상태 아이콘 스타일
export const ClaimStatusIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  
  &.claim-status-not_started {
    color: #dc3545; /* 빨간색 */
  }
  
  &.claim-status-in_progress {
    color: #ffc107; /* 노란색 */
  }
  
  &.claim-status-completed {
    color: #28a745; /* 초록색 */
  }
`;

// 청구 상태 헤더 스타일
export const ClaimStatusHeader = styled.th`
  min-width: 60px;
  text-align: center;
  font-weight: bold;
  background-color: #fb8b24;
  color: #000;
  
  @media (max-width: 1200px) {
    min-width: 55px;
  }
  
  @media (max-width: 768px) {
    min-width: 50px;
  }
  
  @media (max-width: 480px) {
    min-width: 45px;
  }
`;

// 청구 상태 셀 스타일
export const ClaimStatusCell = styled.td`
  text-align: center;
  vertical-align: middle;
  position: relative;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  
  @media (max-width: 1200px) {
    padding: 5px 8px;
  }
  
  @media (max-width: 768px) {
    padding: 4px 6px;
  }
  
  @media (max-width: 480px) {
    padding: 3px 4px;
  }
`;

export const ClaimStatusText = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #28a745;
  line-height: 1;
  text-align: center;
  
  @media (max-width: 1200px) {
    font-size: 9px;
  }
  
  @media (max-width: 768px) {
    font-size: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 7px;
  }
`;

// 만료된 주문서 행 스타일
export const ExpiredOrderRow = styled.tr`
  background: linear-gradient(135deg, #fff5f5 0%, #ffffff 50%, #fff5f5 100%) !important;
  border-left: 4px solid #ff6b6b !important;
  position: relative;
  animation: expiredPulse 3s infinite;
  
  &:hover {
    background: linear-gradient(135deg, #ffebee 0%, #f8f9fa 50%, #ffebee 100%) !important;
    transform: translateX(2px);
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);
  }
  
  td {
    border-color: #ffcdd2 !important;
    color: #d32f2f !important;
    font-weight: 500;
    position: relative;
  }
`;

// 애니메이션 키프레임 추가
const expiredPulse = `
  @keyframes expiredPulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.4);
    }
    50% {
      box-shadow: 0 0 0 8px rgba(255, 107, 107, 0.1);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0);
    }
  }
`;

const badgePulse = `
  @keyframes badgePulse {
    0% {
      transform: scale(1);
      box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
    }
    50% {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.5);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
    }
  }
`;

// 전역 스타일로 애니메이션 추가
export const GlobalStyles = styled.div`
  ${expiredPulse}
  ${badgePulse}
`;